namespace GeniuzPOS.RefundReasonReport {
    export interface ReportRefundReasonByBillRow {
        Id?: string;
        DocDate?: string;
        DocTime?: string;
        DocNo?: string;
        ShopId?: string;
        ShopName?: string;
        CashierId?: string;
        CashierName?: string;
        AppRefund?: string;
        RefundId?: number;
        RefundReason?: string;
        PosId?: string;
        SalesmanId?: string;
        SalesmanName?: string;
        MbId?: string;
        MbNameT?: string;
        GrossSales?: number;
        AllItemDiscount?: number;
        NetSales?: number;
        NetSalesExVat?: number;
        VatOfNetSales?: number;
        VatOfCharge?: number;
        BillCharge?: number;
    }

    export namespace ReportRefundReasonByBillRow {
        export const idProperty = 'Id';
        export const nameProperty = 'DocNo';
        export const localTextPrefix = 'RefundReasonReport.ReportRefundReasonByBill';
        export const lookupKey = 'RefundReasonReport.ReportRefundReasonByBill';

        export function getLookup(): Q.Lookup<ReportRefundReasonByBillRow> {
            return Q.getLookup<ReportRefundReasonByBillRow>('RefundReasonReport.ReportRefundReasonByBill');
        }
        export const deletePermission = '1POSBASE:รายงาน:เหตุผลการคืน:รายงานเหตุผลการคืนรายบิล:View';
        export const insertPermission = '1POSBASE:รายงาน:เหตุผลการคืน:รายงานเหตุผลการคืนรายบิล:View';
        export const readPermission = '1POSBASE:รายงาน:เหตุผลการคืน:รายงานเหตุผลการคืนรายบิล:View';
        export const updatePermission = '1POSBASE:รายงาน:เหตุผลการคืน:รายงานเหตุผลการคืนรายบิล:View';

        export declare const enum Fields {
            Id = "Id",
            DocDate = "DocDate",
            DocTime = "DocTime",
            DocNo = "DocNo",
            ShopId = "ShopId",
            ShopName = "ShopName",
            CashierId = "CashierId",
            CashierName = "CashierName",
            AppRefund = "AppRefund",
            RefundId = "RefundId",
            RefundReason = "RefundReason",
            PosId = "PosId",
            SalesmanId = "SalesmanId",
            SalesmanName = "SalesmanName",
            MbId = "MbId",
            MbNameT = "MbNameT",
            GrossSales = "GrossSales",
            AllItemDiscount = "AllItemDiscount",
            NetSales = "NetSales",
            NetSalesExVat = "NetSalesExVat",
            VatOfNetSales = "VatOfNetSales",
            VatOfCharge = "VatOfCharge",
            BillCharge = "BillCharge"
        }
    }
}
